/* eslint-disable no-console */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import lines from "./lines.json";
import stops from "./stops.json";

const linesColors = Object.fromEntries(lines.map(line => [line.ligne, line.color]));

export default new Vuex.Store({
  state: {
    isSearch: false,
    journeysLoaded: false,
    journeySelected: false,
    query: "",
    stops: stops,
    selectedFilter: "les deux",
    selectedTimeFormat: "simple", // simple | full
    lines,
    linesColors,
    selected: {},
    realtimeResponse: {},
    lastSearch: [],
    times: [],
    handicappedAccess: false,
    searchIsFinished: false,
    infos: [],
    itineraire: {
      onSearch: null,
      query: "",
      search: {
        from: [],
        to: [],
      },
      selected: {
        from: null,
        to: null,
      },
      journeys: [],
      selectedJourney: null,
    },
  },
  mutations: {
    openTravel(state, journey) {
      console.log("openTravel", journey);
      state.itineraire.selectedJourney = journey;
      state.journeySelected = true;
    },
    closeTravel(state) {
      state.itineraire.selectedJourney = null;
      state.journeySelected = false;
    },
    search(state, query) {
      state.query = query ? query : "";
      state.isSearch = Boolean(query);
    },
    startSearch(state) {
      state.isSearch = true;
    },
    select(state, station) {
      console.log("Select");
      console.log(station);
      state.selected = station;
      this.state.times = [];
      if (station.stations[0] == station.direction.a) {
        station.selected = "r";
      }

      // Remove and add on first pos
      // const isExist = state.lastSearch.find(i =>
      //   i.id === state.selected.id &&
      //   i.stations[0] === state.selected.stations[0]
      // );

      const isExist = state.lastSearch.find((i) => i.id === state.selected.id);

      if (isExist) {
        state.lastSearch = state.lastSearch.filter(
          ({ id }) => id !== isExist.id,
        );
        state.lastSearch.push(state.selected);
      } else {
        state.lastSearch.push(state.selected);
      }

      state.lastSearch = state.lastSearch
        .slice()
        .reverse()
        .splice(0, 4)
        .slice()
        .reverse();

      localStorage.setItem("lastSearch", JSON.stringify(state.lastSearch));
      localStorage.setItem("selected", JSON.stringify(state.selected));
    },
    setLastSearch(state, lastSearch) {
      state.lastSearch = lastSearch;
    },
    setTime(state, times) {
      state.times = times;
    },
    changeDirection(state, direction) {
      state.selected.selected = direction;
    },
    selectLineFilter(state, ligne) {
      state.selectedFilter = ligne;
    },
    itineraireQuery(state, value) {
      console.log("query iti", { value });
      if (!value) {
        state.itineraire.onSearch = null;
      }
      state.itineraire.query = value;
    },
    itineraireSearch(state, { dir, value }) {
      console.log("search iti", { dir, value });
      if (["from", "to"].includes(dir)) {
        state.itineraire.onSearch = dir;
        state.itineraire.search[dir] = value;
      }
    },
    itineraireSelect(state, value) {
      console.log("select iti", value);
      if (
        state.itineraire.onSearch &&
        ["from", "to"].includes(state.itineraire.onSearch)
      ) {
        if (value.geometry) {
          console.log("create coordinates");
          value.center = value.geometry
            .replace("POINT (", "")
            .replace(")", "")
            .split(" ");
        }

        state.itineraire.selected[state.itineraire.onSearch] = value;
        state.itineraire.onSearch = null;
        state.itineraire.selectedJourney = null;
      }
    },
    itineraireReverse(state) {
      const from = state.itineraire.selected.from;
      state.itineraire.selected.from = state.itineraire.selected.to;
      state.itineraire.selected.to = from;
    },
    clearItineraire(state) {
      console.log("clear iti");
      this.state.journeysLoaded = false;
      this.state.journeySelected = false;
      state.itineraire = {
        onSearch: null,
        query: "",
        search: {
          from: [],
          to: [],
        },
        selected: {
          from: null,
          to: null,
        },
      };
    },
    addJourneys(state, journeys) {
      state.itineraire.journeys = journeys;
    },
    selectJourney(state, journey) {
      state.itineraire.selectedJourney = journey;
      state.journeySelected = true;
    },
    selectTimeFormat(state, format) {
      state.selectedTimeFormat = format;
      localStorage.setItem("selectedTimeFormat", format);
    },
  },
  actions: {
    async call() {
      this.handicappedAccess = false;
      this.state.searchIsFinished = false;

      const line = this.state.selected.ligne;
      const stop = this.state.selected.stations[0];
      const direction = this.state.selected.direction[
        this.state.selected.selected
      ];

      try {
        const response = await fetch(
          `https://rapidapi.bullshit.video/t2c/realtime/${line}/${stop}/${direction}`
        );
        const result = await response.json();

        this.state.searchIsFinished = true;
        this.state.realtimeResponse = result;
        this.state.handicappedAccess = result.handicapped_access || false;

        const getFormattedTimes = response => {
          const isSimpleFormat =
            this.state.selectedTimeFormat === "simple" &&
            Array.isArray(response.times);

          const isFullFormat =
            this.state.selectedTimeFormat === "full" &&
            Array.isArray(response.full_times);

          if (isSimpleFormat) {
            return response.times;
          } else if (isFullFormat) {
            return response.full_times.map(date => {
              const [hours, minutes] = date
                .split(" ")
                .pop()
                .split(":");

              return `${hours}:${minutes}`;
            });
          }
          return [];
        };

        const times = getFormattedTimes(result);
        this.state.times = times.length ? times.slice(0, 5) : ["Aucun Passage"];
      } catch (error) {
        console.error("Error fetching data:", error);
        this.state.times = ["Aucun Passage"];
      }
    },
    infos({ commit }) {
      // const url = "https://t2c.bullshit.video/infos";
      const url = "https://rapidapi.bullshit.video/t2c/infos";
      // const url = 'http://localhost:4444/infos';
      fetch(url)
        .then((r) => r.json())
        .then((infos) => {
          this.state.infos = infos;
        });
    },
    async findJourney({ commit }) {
      const { selected } = this.state.itineraire;
      if (!selected.from || !selected.to) {
        return;
      }

      this.state.journeysLoaded = false;

      const from = selected.from.text_fr || selected.from.name;
      const to = selected.to.text_fr || selected.to.name;

      const url = `https://t2c.bullshit.video/journey-planner/${from}/${to}`;
      //const url = `http://localhost:8000/journey-planner/${from}/${to}`;
      console.log(url);
      const result = await fetch(url).then((r) => r.json());
      console.log(result);
      this.state.journeysLoaded = true;
      this.state.journeySelected = false;
      this.state.itineraire.journeys = result;
    },
  },
  getters: {
    itineraire: (state) => state.itineraire,
    journeys: (state) => state.itineraire.journeys,
  },
});
